var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { TerceraButtonStyle } from '@shared/utils/Enums/ButtonEnums';
import { TerceraWindowBase } from './TerceraWindowBase';
import CertificateInfoScreenTemplate from '@front/templates/CertificateInfoScreenTemplate.html';
import { MainWindowManager } from '../UtilsClasses/MainWindowManager';
import { Resources } from '@shared/localizations/Resources';
import { setCertificateScreenHandler } from '@shared/utils/MessageBoxUtils';
export class CertificateInfoScreen extends TerceraWindowBase {
    constructor() {
        super();
    }
    oninit() {
        super.oninit();
        this.on('okClick', this.okClick);
        this.on('cancelClick', this.cancelClick);
    }
    applyParameters(parameters, okCallback, cancelCallback) {
        void this.set({
            header: parameters.headerText,
            certificateInfoParams: parameters.certificateInfoParams,
            okText: isValidString(parameters.okButtonText)
                ? parameters.okButtonText
                : Resources.getResource('general.messageBox.ok'),
            cancelText: isValidString(parameters.cancelButtonText)
                ? parameters.cancelButtonText
                : Resources.getResource('general.messageBox.cancel'),
            okCallback,
            cancelCallback
        });
        const params = [];
        for (const key in parameters.certificateInfoParams) {
            params.push({ key, value: parameters.certificateInfoParams[key] });
        }
        void this.set({ certificateInfoParams: params });
    }
    okClick() {
        const okCallBack = this.get('okCallback');
        okCallBack();
    }
    cancelClick() {
        const cancelCallback = this.get('cancelCallback');
        cancelCallback();
    }
    onCloseButtonClick() {
        const okCallBack = this.get('okCallback');
        okCallBack();
        super.onCloseButtonClick();
    }
    static ShowAsync(parameters) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve) => {
                const confirmationScreen = new CertificateInfoScreen();
                confirmationScreen.applyParameters(parameters, () => {
                    confirmationScreen.close();
                    resolve(true);
                }, () => {
                    confirmationScreen.close();
                    resolve(false);
                });
                MainWindowManager.AddControl(confirmationScreen);
                confirmationScreen.setFocus();
                confirmationScreen.center();
            });
        });
    }
}
TerceraWindowBase.extendWith(CertificateInfoScreen, {
    data: function () {
        return {
            errorTop: 0,
            header: '',
            resizable: false,
            showFooter: false,
            okText: '',
            cancelText: '',
            btnOKStyle: TerceraButtonStyle.Blue,
            btnCancelStyle: TerceraButtonStyle.Standard,
            messageBoxType: null,
            okCallback: null,
            cancelCallback: null,
            closeButtonCallBack: null,
            allowKeyboardConfirmation: true,
            showFullscreenCloud: false, // TODO 83829
            certificateInfoParams: null
        };
    },
    partials: { bodyPartial: CertificateInfoScreenTemplate }
});
setCertificateScreenHandler(CertificateInfoScreen.ShowAsync);
